define("calendar/templates/notes/new", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f

  var _default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @close={{perform this.canClose}} @focusTrap={{true}} {{did-insert this.clearExistingContent}} as |modal|>
    <modal.card @portrait={{true}} class="cNO---modalCard">
      <modal.card-header class="u--p__b">
        <h2 class="o--modalHeader__title u--text--light">
          {{svg-jar "notes" class="o--icon o--icon--light u--float--right"}}
          {{t "calendar_notes.notes" count=1}}
        </h2>
        <p class="u--text--sm u--text--light u--m__b__0">
          {{t "calendar_notes.visible_to_all_users"}}
        </p>
      </modal.card-header>
      <modal.card-body class="u--p__t__0">
        {{! Emoji Text Area  }}
        <Shared::EmojiTextarea
          @class="cPM--post__textarea e--modal__captionTextarea e--autosize"
          @name="caption"
          @placeholder="Enter your note text here"
          @value={{this.noteContent}}
        />
        <div class="u--m__t__xs">
          <Shared::Ui::Button
            @class="u--text--sm u--text--light u--float--left"
            @onClick={{perform this.copyToClipboard}}
            @variant="actionLink"
          >
            {{svg-jar "copy" class="o--icon--sm"}}
            {{t "calendar_notes.copy_to_clipboard"}}
          </Shared::Ui::Button>
          {{! Note to Dev: will only appear on notes when 100 character are left }}
          {{#if this.showCharacterLimit}}
            <span class="u--text--danger u--text--sm u--float--right">
              {{t "posts.edit.post_metadata.characters_left" count=this.charactersRemaining}}
            </span>
          {{/if}}
        </div>
      </modal.card-body>
      <modal.card-footer class="cNO---modalFooter">
        <Shared::Ui::Button
          @class="e--modal--delete"
          @onClick={{perform this.deleteCalendarNote}}
          @text={{t "calendar_notes.discard_note"}}
          @variant="outline"
        />
        <Shared::Ui::Button
          @class="u--float--right e--modal--save"
          @isDisabled={{not this.allowSave}}
          @onClick={{perform this.addNewCalendarNote}}
          @text={{t "shared_words.save"}}
        />
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "HMIjUHEj",
    "block": "[[[8,[39,0],[[4,[38,2],[[30,0,[\"clearExistingContent\"]]],null]],[[\"@close\",\"@focusTrap\"],[[28,[37,1],[[30,0,[\"canClose\"]]],null],true]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],[[24,0,\"cNO---modalCard\"]],[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__b\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,\"h2\"],[14,0,\"o--modalHeader__title u--text--light\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"notes\"],[[\"class\"],[\"o--icon o--icon--light u--float--right\"]]]],[1,\"\\n        \"],[1,[28,[35,4],[\"calendar_notes.notes\"],[[\"count\"],[1]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--text--sm u--text--light u--m__b__0\"],[12],[1,\"\\n        \"],[1,[28,[35,4],[\"calendar_notes.visible_to_all_users\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n\"],[1,\"      \"],[8,[39,5],null,[[\"@class\",\"@name\",\"@placeholder\",\"@value\"],[\"cPM--post__textarea e--modal__captionTextarea e--autosize\",\"caption\",\"Enter your note text here\",[30,0,[\"noteContent\"]]]],null],[1,\"\\n      \"],[10,0],[14,0,\"u--m__t__xs\"],[12],[1,\"\\n        \"],[8,[39,6],null,[[\"@class\",\"@onClick\",\"@variant\"],[\"u--text--sm u--text--light u--float--left\",[28,[37,1],[[30,0,[\"copyToClipboard\"]]],null],\"actionLink\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,3],[\"copy\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n          \"],[1,[28,[35,4],[\"calendar_notes.copy_to_clipboard\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"],[41,[30,0,[\"showCharacterLimit\"]],[[[1,\"          \"],[10,1],[14,0,\"u--text--danger u--text--sm u--float--right\"],[12],[1,\"\\n            \"],[1,[28,[35,4],[\"posts.edit.post_metadata.characters_left\"],[[\"count\"],[[30,0,[\"charactersRemaining\"]]]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"card-footer\"]],[[24,0,\"cNO---modalFooter\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,6],null,[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"e--modal--delete\",[28,[37,1],[[30,0,[\"deleteCalendarNote\"]]],null],[28,[37,4],[\"calendar_notes.discard_note\"],null],\"outline\"]],null],[1,\"\\n      \"],[8,[39,6],null,[[\"@class\",\"@isDisabled\",\"@onClick\",\"@text\"],[\"u--float--right e--modal--save\",[28,[37,8],[[30,0,[\"allowSave\"]]],null],[28,[37,1],[[30,0,[\"addNewCalendarNote\"]]],null],[28,[37,4],[\"shared_words.save\"],null]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\"],false,[\"shared/modal\",\"perform\",\"did-insert\",\"svg-jar\",\"t\",\"shared/emoji-textarea\",\"shared/ui/button\",\"if\",\"not\"]]",
    "moduleName": "calendar/templates/notes/new.hbs",
    "isStrictMode": false
  });

  _exports.default = _default;
});